import React from 'react';
import { Typography, Card, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;

const Privacy = () => (
  <div style={{ maxWidth: 800, margin: '20px auto', padding: '0 16px' }}>
    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
      <Title level={2}>隐私政策</Title>
      <Text style={{ color: '#666' }}>最后更新时间：2026年6月16日</Text>
    </div>

    <Card>
      <Title level={3}>1. 引言</Title>
      <Paragraph>
        漳浦声语文化传媒有限公司（以下简称"我们"）非常重视您的隐私保护。本隐私政策详细说明了我们如何收集、使用、存储和保护您的个人信息。
      </Paragraph>
      <Paragraph>
        请您在使用我们的服务前仔细阅读本隐私政策。如果您不同意本隐私政策的任何内容，请不要使用我们的服务。
      </Paragraph>

      <Title level={3}>2. 信息收集</Title>
      <Paragraph>
        我们收集以下类型的信息：
      </Paragraph>
      
      <Title level={4}>2.1 账户信息</Title>
      <ul>
        <li>手机号码：用于账户注册和身份验证</li>
        <li>密码：用于账户安全保护（加密存储）</li>
        <li>昵称：用于个性化显示</li>
        <li>微信OpenID：用于微信登录和支付（仅在使用微信功能时收集）</li>
      </ul>

      <Title level={4}>2.2 使用信息</Title>
      <ul>
        <li>功能使用记录：记录您使用的功能模块</li>
        <li>操作日志：记录您的操作行为（用于改进服务）</li>
        <li>设备信息：设备型号、操作系统版本、浏览器类型</li>
        <li>IP地址：用于安全防护和统计分析</li>
      </ul>

      <Title level={4}>2.3 内容信息</Title>
      <ul>
        <li>您上传的文件、图片等资料</li>
        <li>您创建的数据记录（文件、物品、财务等）</li>
        <li>您填写的个人信息</li>
      </ul>

      <Title level={3}>3. 信息使用</Title>
      <Paragraph>
        我们收集您的信息用于以下目的：
      </Paragraph>
      <ul>
        <li>提供、维护和改进我们的服务</li>
        <li>处理您的账户注册和身份验证</li>
        <li>处理您的支付和会员服务</li>
        <li>提供客户支持和技术服务</li>
        <li>发送重要通知和服务更新</li>
        <li>进行数据分析和产品优化</li>
        <li>防范安全威胁和欺诈行为</li>
        <li>遵守法律法规要求</li>
      </ul>

      <Title level={3}>4. 信息共享</Title>
      <Paragraph>
        我们不会出售、出租或以其他方式披露您的个人信息，除非：
      </Paragraph>
      <ul>
        <li>获得您的明确同意</li>
        <li>为提供服务所必需（如支付处理）</li>
        <li>法律法规要求</li>
        <li>保护我们的合法权益</li>
        <li>保护用户或公众的安全</li>
      </ul>

      <Title level={3}>5. 信息存储</Title>
      <Paragraph>
        5.1 我们采用行业标准的安全措施保护您的信息，包括：
      </Paragraph>
      <ul>
        <li>HTTPS加密传输</li>
        <li>密码bcrypt加密存储</li>
        <li>数据库访问权限控制</li>
        <li>定期安全审计</li>
        <li>数据备份和恢复</li>
      </ul>
      <Paragraph>
        5.2 您的信息主要存储在中国境内的服务器上。
      </Paragraph>
      <Paragraph>
        5.3 我们仅在提供服务所必需的期间内保留您的信息。
      </Paragraph>

      <Title level={3}>6. Cookie和类似技术</Title>
      <Paragraph>
        6.1 我们使用Cookie和类似技术来改善用户体验，包括：
      </Paragraph>
      <ul>
        <li>记住您的登录状态</li>
        <li>保存您的偏好设置</li>
        <li>分析网站使用情况</li>
        <li>提供个性化内容</li>
      </ul>
      <Paragraph>
        6.2 您可以通过浏览器设置管理Cookie，但禁用Cookie可能影响部分功能。
      </Paragraph>

      <Title level={3}>7. 第三方服务</Title>
      <Paragraph>
        我们可能使用以下第三方服务：
      </Paragraph>
      <ul>
        <li>微信开放平台：用于微信登录和支付</li>
        <li>短信服务商：用于发送验证码</li>
        <li>云存储服务：用于数据存储和备份</li>
        <li>统计分析服务：用于了解服务使用情况</li>
      </ul>
      <Paragraph>
        这些第三方服务有自己的隐私政策，我们建议您查看相关条款。
      </Paragraph>

      <Title level={3}>8. 您的权利</Title>
      <Paragraph>
        您对个人信息享有以下权利：
      </Paragraph>
      <ul>
        <li>访问权：查看我们持有的您的个人信息</li>
        <li>更正权：更正不准确的个人信息</li>
        <li>删除权：要求删除您的个人信息</li>
        <li>限制处理权：限制我们处理您的个人信息</li>
        <li>数据可携权：获取您的个人数据副本</li>
        <li>反对权：反对我们处理您的个人信息</li>
      </ul>
      <Paragraph>
        如需行使上述权利，请联系我们：support@manage.net.cn
      </Paragraph>

      <Title level={3}>9. 儿童隐私</Title>
      <Paragraph>
        我们的服务不面向14岁以下的儿童。如果我们发现收集了儿童的个人信息，将立即删除相关信息。
      </Paragraph>

      <Title level={3}>10. 隐私政策更新</Title>
      <Paragraph>
        10.1 我们可能会不时更新本隐私政策。
      </Paragraph>
      <Paragraph>
        10.2 重大变更将通过服务页面或邮件通知您。
      </Paragraph>
      <Paragraph>
        10.3 继续使用服务即表示您同意更新后的隐私政策。
      </Paragraph>

      <Title level={3}>11. 账号注销规则</Title>
      <Paragraph>
        如您不再使用本应用，可按以下方式申请账号注销：
      </Paragraph>
      <ul>
        <li><strong>APP 内自助注销</strong>：登录后在首页底部「法律与账号」→「账号注销」，按提示输入密码并确认。</li>
        <li><strong>网页自助注销</strong>：登录后进入「个人中心」→「法律与账号」→「账号注销」。</li>
        <li><strong>邮箱注销</strong>：发送邮件至 <strong>support@manage.net.cn</strong>，邮件标题注明「账号注销申请」，并附上注册手机号。</li>
      </ul>
      <Paragraph>
        <strong>隐私政策在线地址：</strong>
        <a href="https://manage.net.cn/privacy" target="_blank" rel="noopener noreferrer">https://manage.net.cn/privacy</a>
      </Paragraph>
      <Paragraph>
        <strong>用户协议在线地址：</strong>
        <a href="https://manage.net.cn/terms" target="_blank" rel="noopener noreferrer">https://manage.net.cn/terms</a>
      </Paragraph>
      <Paragraph>
        我们将在核验身份后尽快处理注销申请。账号注销后，将删除或匿名化处理相关个人信息；但法律法规要求保留的信息除外。
      </Paragraph>

      <Title level={3}>12. 联系我们</Title>
      <Paragraph>
        如果您对本隐私政策有任何疑问或建议，请通过以下方式联系我们：
      </Paragraph>
      <ul>
        <li>邮箱：support@manage.net.cn</li>
        <li>网站：https://manage.net.cn</li>
        <li>应用内：个人中心 - 联系客服</li>
      </ul>

      <Divider />

      <div style={{ textAlign: 'center', color: '#666' }}>
        <Text>
          我们承诺保护您的隐私，感谢您对管理师软件的信任！
        </Text>
      </div>
    </Card>
  </div>
);

export default Privacy;
